import { getDealCreated, getMonthWiseInterest, getMonthWiseInterestForFinUser } from "http/UAM/userDashboardWidget.helper";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import PropTypes from 'prop-types';
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";
import { decryptedValue } from "common/utility";

const DealsCreated = ({ userType }) => {
  const [dealsData, setDealsData] = useState([]);
  const [filter, setFilter] = useState('count')
  const [showStatus, setShowStatus] = useState(true)
  const user = decryptedValue(localStorage.getItem("user"));
  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const currencyShotern = (amount) => {
    if (amount && !isNaN(amount) && amount != undefined) {
      const formatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        notation: "compact",
        compactDisplay: "long",
      });
      return formatter.format(amount);
    } else return "0.00";
  };

  useEffect(() => {
    if (userType === "admin" || userType == "admin_operations" || userType == "partner" || userType == "RM" || userType == "FI_RM" || userType == "program_manager" || userType == "reporting_manager" || userType == "program Team") {
      getDealCreated({ type: filter, user: user }).then((res) => {
        const allDealCountsAreZero =res.data.some(item => item.dealCount != '0');
        setShowStatus(allDealCountsAreZero)
        setDealsData(res.data);
      });
    } else if (userType === "financier_operations") {
      getMonthWiseInterestForFinUser({ type: filter }).then((res) => {
        const allDealCountsAreZero =res.data.some(item => item.dealCount != '0');
        setShowStatus(allDealCountsAreZero)
        setDealsData(res.data);
      })
    }
    else {
      getMonthWiseInterest({ type: filter }).then((res) => {
        setDealsData(res.data);
        const allDealCountsAreZero =res.data.some(item => item.dealCount != '0');
        setShowStatus(allDealCountsAreZero)
      })
    }

  }, [filter, userType]);
  const options = {
    chart: {
      type: "area",
      height: 350,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    xaxis: {
      categories: dealsData.map((data) => data.monthYear),
      labels: {
        style: {
          colors: "#333",
        },
      },
    },
    yaxis: {
      title: {
        text: 'Deals'
      },
      labels: {
        formatter: (val) => {
          if (filter !== "count") {
            return currencyShotern(val);
          } else {
            return val;
          }
        },
        style: {
          colors: "#333",
        },
      },
    },
    colors: ["#4CAF50"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    tooltip: {
      x: { show: false },
    },

  };

  const series = [
    {
      name: "Deals Created",
      data: dealsData.map((data) => parseInt(data.dealCount)),
    },
  ];
  return (
    <Card>
      {showStatus ? <CardBody>
        <Row className="mb-2 custom-container">
          <Col  lg='6' sm='12'>
            <h4 className="card-title mb-2">{(userType === "admin" || userType == "admin_operations" || userType == "partner") ? "Deals Created" : "Deals Created"}</h4>
          </Col>
          <Col  lg='6' sm='12' className="mb-2">
            <select
              className="form-select"
              id="filterOptions"
              value={filter}
              onChange={handleFilterChange}
            >
              <option value="count">Count</option>
              <option value="amount">Amount (INR)</option>
            </select>
          </Col>
        </Row>
        <div id="vertical-bar-chart-top-financiers">
          <ReactApexChart
            options={options}
            series={series}
            type="area"
            height={270}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="We couldn't find the Deal Created" />}
    </Card>
  );
};

DealsCreated.propTypes = {
  userType: PropTypes.string.isRequired,
}

export default DealsCreated;
